"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  function Builder() {
    _classCallCheck(this, Builder);
    return _callSuper(this, Builder, arguments);
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        file = _this$props$fields.file,
        mobileText = _this$props$fields.mobileText,
        mobileThumbnail = _this$props$fields.mobileThumbnail,
        downloadButtonLabel = _this$props$fields.downloadButtonLabel;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: file,
        label: "PDF file"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].file
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "large",
        title: "Select file",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default"
        }, "Select file"),
        render: function render(_ref) {
          var closeModal = _ref.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.AssetPicker, _extends({
            globalFilter: "pdf"
          }, file.value ? {
            initialSelectedFile: file.value.resourceId
          } : {}, {
            render: function render(_ref2) {
              var body = _ref2.body,
                selectedFile = _ref2.selectedFile;
              return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  marginTop: '1em'
                }
              }, /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-primary",
                disabled: !selectedFile,
                onClick: function onClick() {
                  file.onChange({
                    resourceId: selectedFile.id,
                    name: selectedFile.name,
                    url: selectedFile.url
                  });
                  closeModal();
                }
              }, "Select file")));
            }
          }));
        }
      }), file.value && /*#__PURE__*/_react["default"].createElement("div", null, file.value.name))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: downloadButtonLabel,
        label: "Download button label"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: mobileText,
        label: "Text if inline PDF is not supported",
        isWysiwyg: true,
        wysiwygProps: {
          type: 'textarea-inline',
          settings: {
            convert_urls: false
          }
        },
        comment: "You can use [url] and [name] as variables"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: mobileThumbnail,
        label: "Thumbnail if inline PDF is not supported"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "large",
        title: "Select image",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default"
        }, "Select image"),
        render: function render(_ref3) {
          var closeModal = _ref3.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.AssetPicker, _extends({
            globalFilter: "image"
          }, mobileThumbnail.value ? {
            initialSelectedFile: mobileThumbnail.value.resourceId
          } : {}, {
            render: function render(_ref4) {
              var body = _ref4.body,
                selectedFile = _ref4.selectedFile;
              return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].buttons
              }, /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-primary",
                disabled: !selectedFile,
                onClick: function onClick() {
                  mobileThumbnail.onChange({
                    resourceId: selectedFile.id,
                    name: selectedFile.name,
                    url: selectedFile.thumbnailLarge
                  });
                  closeModal();
                }
              }, "Select file"), mobileThumbnail.value && /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-warning",
                onClick: function onClick() {
                  mobileThumbnail.onChange(null);
                  closeModal();
                }
              }, "Unattach file")));
            }
          }));
        }
      })), mobileThumbnail.value && /*#__PURE__*/_react["default"].createElement("img", {
        width: "200px",
        alt: "thumbnail",
        src: mobileThumbnail.value.url,
        style: {
          marginTop: '1rem'
        }
      })));
    }
  }]);
  return Builder;
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true,
  withVisibilityConditions: true
})(Builder);